/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2AddAppointmentNote/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2AddAppointmentNote({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2AddAppointmentNote",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#CBD2D9"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2AddAppointmentNote.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z1RHyOF': alignSelf,'--mt-2-Z1RHyOF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1RHyOF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1RHyOF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1RHyOF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1RHyOF': opacity,'--w-10-Z1RHyOF': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1RHyOF': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1RHyOF': fill,'--a-7-Z1RHyOF': isAnimated ? animation : "none",'--sd-8-Z1RHyOF': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1RHyOF': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2AddAppointmentNote.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7.179 12H1.286C.576 12 0 11.424 0 10.714V1.286C0 .576.576 0 1.286 0h9.428C11.424 0 12 .576 12 1.286v5.892H7.714a.536.536 0 00-.535.536V12zm1.071-.536l3.215-3.214H8.25v3.214zM4.714 1.5c.355 0 .643.288.643.643v1.5h1.5a.643.643 0 010 1.286h-1.5v1.5a.643.643 0 11-1.286 0v-1.5h-1.5a.643.643 0 110-1.286h1.5v-1.5c0-.355.288-.643.643-.643z"
 style={{'--f-12-Z1RHyOF': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}